import { COMPANY_MODAL_ACTION_TYPE } from "../actions-type";

const initialState = {
  companyModalData: {},
  companyOpenModal: false,
  companyModalLoading: false,
};

export const companyModalReducer = (state = initialState, action) => {
  switch (action.type) {
    case COMPANY_MODAL_ACTION_TYPE.GET_COMPANY_MODAL:
      return {
        ...state,
        companyModalData: action.payload.data,
        companyOpenModal: action.payload.openModal,
      };
    case COMPANY_MODAL_ACTION_TYPE.COMPANY_OPEN_MODAL:
      return {
        ...state,
        companyOpenModal: action.payload,
      };
    case COMPANY_MODAL_ACTION_TYPE.COMPANY_MODAL_LOADING:
      return {
        ...state,
        companyModalLoading: action.payload,
      };
    default:
      return state;
  }
};
